import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

let token;

export function setToken(newToken) {
    token = newToken;
}

const authHeaders = () => (token ? { Authorization: `Bearer ${token}` } : {});
const jsonHeaders = () => ({ 'Content-Type': 'application/json', ...authHeaders() });
const url = (route) => `${API_BASE_URL}${route.startsWith('/') ? '' : '/'}${route}`;

// ===== Transforms =====

export const fetchTransforms = async () => {
    const res = await axios.get(url('/transforms'), { headers: authHeaders() });
    return res.data;
};

export const fetchTransform = async (transformId) => {
    const res = await axios.get(url(`/transforms/${transformId}`), { headers: authHeaders() });
    return res.data;
};

export const createTransform = async (payload) => {
    const res = await axios.post(url('/transforms'), payload, { headers: jsonHeaders() });
    return res.data;
};

export const updateTransform = async (transformId, payload) => {
    const res = await axios.put(url(`/transforms/${transformId}`), payload, { headers: jsonHeaders() });
    return res.data;
};

export const deleteTransform = async (transformId) => {
    const res = await axios.delete(url(`/transforms/${transformId}`), { headers: authHeaders() });
    return res.data;
};

// ===== Abilities (shared pool of skillset-8 skills) =====

export const fetchAbilities = async () => {
    const res = await axios.get(url('/transforms/abilities'), { headers: authHeaders() });
    return res.data;
};

export const createAbility = async ({ name, notes }) => {
    const res = await axios.post(url('/transforms/abilities'), { name, notes }, { headers: jsonHeaders() });
    return res.data; // { skillId, name, notes }
};

// Updates the shared ability for every transform that references it.
export const updateAbility = async (skillId, { name, notes }) => {
    const res = await axios.put(url(`/transforms/abilities/${skillId}`), { name, notes }, { headers: jsonHeaders() });
    return res.data; // { skillId, name, notes }
};
